import type { ReactElement } from 'react';
import { Button } from './Button';
import { useNotices } from './Notices';
import { copyText } from '../lib/note';

/**
 * Something to copy, shown as what it is.
 *
 * A command or a config block is not prose: it must survive being read
 * character by character, so it is monospaced, it wraps rather than being cut
 * off, and the whole of it goes to the clipboard in one press. A snippet
 * somebody has to select by hand is a snippet somebody pastes half of.
 */
export function Snippet({ code, where }: { code: string; where?: string }): ReactElement {
  const { show } = useNotices();
  return (
    <div className="snippet">
      {where ? <span className="snippet-where mono">{where}</span> : null}
      <pre className="snippet-code">{code}</pre>
      <Button
        size="sm"
        variant="quiet"
        onClick={() => void copyText(code).then(() => show({ tone: 'success', text: 'Copied.' }))}
      >
        Copy
      </Button>
    </div>
  );
}
